var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "white",
    stroke: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 83.3334C31.59 83.3334 16.6667 68.4101 16.6667 50.0001C16.6667 31.5901 31.59 16.6667 50 16.6667C68.41 16.6667 83.3333 31.5901 83.3333 50.0001C83.3333 68.4101 68.41 83.3334 50 83.3334ZM33.3333 50.0001C33.3333 54.4204 35.0893 58.6596 38.2149 61.7852C41.3405 64.9108 45.5797 66.6668 50 66.6668C54.4203 66.6668 58.6595 64.9108 61.7851 61.7852C64.9107 58.6596 66.6667 54.4204 66.6667 50.0001H60C60 52.6522 58.9464 55.1958 57.0711 57.0712C55.1957 58.9465 52.6522 60.0001 50 60.0001C47.3478 60.0001 44.8043 58.9465 42.9289 57.0712C41.0536 55.1958 40 52.6522 40 50.0001H33.3333Z",
    fill: "#EDEDED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.9c994f73330e1e097b25e4e10abfce12.svg";
export { ForwardRef as ReactComponent };